/* tslint:disable */
/* eslint-disable */
import type { PaxCheckManualDocument } from './PaxCheckManualDocument';
import { PaxCheckManualDocumentToJSON } from './PaxCheckManualDocument';

export interface PaxCheckApplyManualDocumentRequest {
    document: PaxCheckManualDocument;
    ignoreMistakes: boolean;
}

export function instanceOfPaxCheckApplyManualDocumentRequest(value: object): value is PaxCheckApplyManualDocumentRequest {
    if (!('document' in value) || value['document'] === undefined) return false;
    if (!('ignoreMistakes' in value) || value['ignoreMistakes'] === undefined) return false;
    return true;
}

export function PaxCheckApplyManualDocumentRequestFromJSON(json: any): PaxCheckApplyManualDocumentRequest {
    return PaxCheckApplyManualDocumentRequestFromJSONTyped(json, false);
}

export function PaxCheckApplyManualDocumentRequestFromJSONTyped(json: any, _ignoreDiscriminator: boolean): PaxCheckApplyManualDocumentRequest {
    if (json == null) return json;
    return {
        document: json['document'],
        ignoreMistakes: json['ignore_mistakes'],
    };
}

export function PaxCheckApplyManualDocumentRequestToJSON(value?: PaxCheckApplyManualDocumentRequest | null): any {
    if (value == null) return value;
    return {
        document: PaxCheckManualDocumentToJSON(value.document),
        ignore_mistakes: value.ignoreMistakes,
    };
}
